import React from "react";
import { XOutlined } from "@phonepe/enigma-ui-icons";
import { ButtonProps } from "antd";
import isNull from "lodash/isNull";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { Size } from "@type/sizing";
import {
    StyledModal,
    StyledDivider,
    StyledHeader,
    StyledCancelButton,
    StyledTitle,
} from "./modal.styles";
import { ModalProps } from "./modal.types";

export const ModalWidthMappings = {
    small: 400,
    medium: 640,
    large: 960,
};

const DEFAULT_FOOTER_BUTTON_PROPS: ButtonProps = {
    size: "large",
    className: "enigma-modal-button",
};

const DEFAULT_CLASSNAMES: ModalProps["classNames"] = {
    footer: "enigma-modal-footer",
    content: "enigma-modal-content",
    header: "enigma-modal-header",
};

export const Modal: React.FC<ModalProps> = ({
    children,
    okText = "Confirm",
    cancelText = "Cancel",
    classNames,
    title = "",
    footer,
    onCancel,
    closable = true,
    closeIcon = <XOutlined />,
    size = "medium",
    width = null,
    ...rest
}) => {
    const okButtonProps = {
        ...DEFAULT_FOOTER_BUTTON_PROPS,
    };

    const cancelButtonProps = {
        ...DEFAULT_FOOTER_BUTTON_PROPS,
    };

    const token = useEnigmaToken();

    return (
        <StyledModal
            {...rest}
            token={token}
            okText={okText}
            cancelText={cancelText}
            okButtonProps={okButtonProps}
            cancelButtonProps={cancelButtonProps}
            classNames={{ ...DEFAULT_CLASSNAMES, ...classNames }}
            closeIcon={null}
            onCancel={onCancel}
            width={width ?? ModalWidthMappings[size]}
            title={
                <StyledHeader closable={!!closable} token={token}>
                    {closable && (
                        <StyledCancelButton onClick={onCancel}>
                            {closeIcon}
                        </StyledCancelButton>
                    )}
                    <StyledTitle>{title}</StyledTitle>
                </StyledHeader>
            }
            footer={footer}
            size={size}
        >
            {children}
            {size === Size.large && !isNull(footer) ? (
                <StyledDivider token={token} />
            ) : null}
        </StyledModal>
    );
};
